import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IStore, IStoreDetails } from "../../models/store/response";
import {
  ICreateStore,
  IUpdateStore,
} from "../../models/store/request";
import { IStoreJoinRequestQuery } from "../../models/store-join-request/query";
import { IStoreJoinRequest } from "../../models/store-join-request/response";

export type StoreJoinRequest = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: StoreJoinRequest[];

  list?: IBaseListingResponse<IStoreJoinRequest>;
  query: IStoreJoinRequestQuery;

  details?: IStoreJoinRequest;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;

    createStore: (request: ICreateStore) => void;
    updateStore: (id: number, request: IUpdateStore) => void;
    deleteStoreJoinRequest: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: IStoreJoinRequestQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createStore: DEFAULT_FUNCTION,
    updateStore: DEFAULT_FUNCTION,
    deleteStoreJoinRequest: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const StoreJoinRequestContext = createContext(externalState);

export default StoreJoinRequestContext;
